export const CALIBRATION_OPERATOR_ROLE = "ROLE_CALIBRATION_OPERATOR";

export function getAuthorities(user) {
  const authorities = user?.authorities ?? user?.user?.authorities ?? [];

  if (typeof authorities === "string") {
    return authorities
      .split(",")
      .map((authority) => authority.trim())
      .filter(Boolean);
  }

  if (!Array.isArray(authorities)) {
    return [];
  }

  return authorities
    .map((authority) =>
      typeof authority === "string" ? authority : authority?.authority
    )
    .filter(Boolean);
}

export function isCalibrationOperator(user) {
  return getAuthorities(user).includes(CALIBRATION_OPERATOR_ROLE);
}
